// src/pages/Apply.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./PageStyles.css";

const Apply = () => {
  const navigate = useNavigate();

  return (
    <section className="apply-hero">
      <div className="apply-overlay"></div>

      <div className="apply-content">
        <h1 className="apply-heading">Shaping the World!</h1>
        <p className="apply-subtext">
          Take your place among the future diplomats, debaters, and changemakers.  
          Apply now and be part of a global experience — where your voice shapes the world.
        </p>

        <button className="apply-btn-hero" onClick={() => navigate("/apply-form")}>
          Apply Now
        </button>
      </div>
    </section>
  );
};

export default Apply;
